import SupplierOrders from './SupplierOrders';

export default SupplierOrders;